module.exports = __webpack_public_path__ + "img/erb-benovelty.dbc83b04.jpg";